export default {
      id: "oc-minimize-usage",
      viewBox: "0 0 1024 1024",
      url: __webpack_public_path__ + "sprite.svg#oc-minimize",
      toString: function () {
        return this.url;
      }
    }